import { WC_LEGACY_ALL_SUBTYPES_VALUE, formatWcSubtypeOptionLabel } from './wc-claim-type-labels';
import type { LobItem } from '../../models/api/reports/lob-filter';

/** WC Injury Codes parity: `code - description` (see `wcInjuryDisplayLabel` on query-parameter-panel-host). */
export function dsCodeDashLabel(code: string | undefined, description: string | undefined): string {
  const c = code?.trim();
  const d = description?.trim();
  if (c && d) {
    return `${c} - ${d}`;
  }
  if (c) {
    return c;
  }
  if (d) {
    return d;
  }
  return '';
}

/** WC parity: empty subtype code → "Include Claims with no Subtype" (see `formatWcSubtypeOptionLabel`). */
export function dsMapClaimTypeOpts(rows: { description: string; code: string }[]): { label: string; value: string }[] {
  const mapped = (rows ?? []).map((r) => {
    const code = String(r.code ?? '').trim();
    if (code === '') {
      const asLob: LobItem = {
        value: '',
        description: (r.description ?? '').trim(),
        isAll: false,
      };
      return { label: formatWcSubtypeOptionLabel(asLob), value: '' };
    }
    return { label: dsCodeDashLabel(code, r.description), value: code };
  });
  const noSubtype = mapped.filter((o) => o.value === '');
  const rest = mapped
    .filter((o) => o.value !== '')
    .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
  // Legacy: second row after "All" is "Include Claims with no Subtype"; remainder A–Z.
  return [...noSubtype, ...rest];
}

/** WC parity: first option is "All" (ALL) unless the API already sent it. */
export function dsPrependAllSubtypeOption(opts: { label: string; value: string }[]): { label: string; value: string }[] {
  if (opts.some((o) => o.value === WC_LEGACY_ALL_SUBTYPES_VALUE)) {
    return opts;
  }
  return [{ label: 'All', value: WC_LEGACY_ALL_SUBTYPES_VALUE }, ...opts];
}
